import React, { useEffect, useState } from "react";
import {
  ArrowBlue,
  ArrowGreen,
  ArrowOrange,
  ArrowPurpal,
} from "../../assets/icon/FetureIcon";
import { useInView } from "react-intersection-observer";

const Roadmap = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const progress = (scrollPosition / (documentHeight - windowHeight)) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="pb-12 lg:pb-100">
      <div className="container">
        <div className="text-center pb-6 lg:py-60">
          <h3
            className="title pb-5 tab:pb-30 border-b border-border_sec wow animate__animated animate__fadeIn"
            data-wow-delay="0.3s"
          >
            Roadmap
          </h3>
        </div>

        {/* Deskotp */}
        <div className="max-w-[1096px] mx-auto grid gap-5 relative center-borders max-lg:hidden wow animate__animated animate__fadeInUp">
          <div
            className={`grid grid-cols-2 items-center relative ${
              scrollProgress >= 0 ? "border-after-blue border-after" : ""
            }`}
          >
            <div className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute bg-shadow-blue shadow-after">
              <div className="bg-lan_primary rounded-full h-4 w-4 border-2 border-white"></div>
            </div>
            <div className="relative">
              <div className="h-px w-full right-0 top-1/2 -translate-y-1/2 border-dashed border border-lan_primary absolute -z-10">
                {/* Border Dashed */}
              </div>

              <div className="relative p-px rounded-lg bg-borderBlue max-w-[450px] w-full">
                <div class="bg-white rounded-md text-black h-full">
                  <div className="p-6 bg-lan_primary/10 rounded-md h-full">
                    <h6 className="text-black font-semibold">
                      Foundation Release{" "}
                    </h6>

                    {/* Border */}
                    <div className="h-px w-full bg-borderBlue my-5"></div>

                    {/* Milestones */}
                    <p className="flex items-center gap-3 font-medium mb-2.5">
                      <ArrowBlue />
                      Milestones
                    </p>
                    <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                      <li>Core AI integration framework</li>
                      <li>Basic warehouse SOP management</li>
                      <li>Educational platform MVP</li>
                      <li>Initial mentorship features</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="ps-50">
              <h4 className="text-lan_primary font-bold">Phase - 1</h4>
            </div>
          </div>
          <div
            className={`grid grid-cols-2 items-center relative ${
              scrollProgress >= 25 ? "border-after-green border-after" : ""
            }`}
          >
            <div
              className={`left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute  ${
                scrollProgress >= 25 ? "bg-shadow-green shadow-after" : ""
              }`}
            >
              <div
                className={` rounded-full h-4 w-4 border-2  ${
                  scrollProgress >= 25
                    ? "bg-green border-white"
                    : "bg-white border-green"
                }`}
              ></div>
            </div>
            <div className="pe-50">
              <h4 className="text-green font-bold text-end">Phase - 2</h4>
            </div>

            <div className="relative p-px rounded-lg bg-borderGreen border-borderGreen max-w-[450px] w-full ml-14 lgs:ml-100">
              <div className="h-px w-full -left-14 lgs:-left-[100px] top-1/2 -translate-y-1/2 border-dashed border border-green absolute -z-10 border-spacing-x-7">
                {/* Border Dashed */}
              </div>
              <div class="bg-white rounded-md text-black h-full">
                <div className="p-6 bg-green/10 rounded-md h-full">
                  <h6 className="text-black font-semibold">
                    Enhanced Features
                  </h6>

                  {/* Border */}
                  <div className="h-px w-full bg-borderGreen my-5"></div>

                  {/* Milestones */}
                  <p className="flex items-center gap-3 font-medium mb-2.5">
                    <ArrowGreen />
                    Milestones
                  </p>
                  <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                    <li>Advanced AI algorithms deployment</li>
                    <li>Extended warehouse automation</li>
                    <li>Interactive learning modules</li>
                    <li>Expanded mentorship capabilities</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`grid grid-cols-2 items-center relative ${
              scrollProgress >= 50 ? "border-after-purpal border-after" : ""
            }`}
          >
            <div
              className={`left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute  ${
                scrollProgress >= 50 ? "bg-shadow-purpal shadow-after" : ""
              }`}
            >
              <div
                className={` rounded-full h-4 w-4 border-2  ${
                  scrollProgress >= 50
                    ? "bg-purple border-white"
                    : "bg-white border-purple"
                }`}
              ></div>
            </div>
            <div className="relative">
              <div className="h-px w-full right-0 top-1/2 -translate-y-1/2 border-dashed border border-purple absolute -z-10">
                {/* Border Dashed */}
              </div>

              <div className="relative p-px rounded-lg bg-purpals max-w-[450px] w-full">
                <div class="bg-white rounded-md text-black h-full">
                  <div className="p-6 bg-purple/10 rounded-md h-full">
                    <h6 className="text-black font-semibold">
                      Scale & Integration
                    </h6>

                    {/* Border */}
                    <div className="h-px w-full bg-borderPurpal my-5"></div>

                    {/* Milestones */}
                    <p className="flex items-center gap-3 font-medium mb-2.5">
                      <ArrowPurpal />
                      Milestones
                    </p>
                    <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                      <li>Enterprise-scale deployment options</li>
                      <li>Cross-platform integration</li>
                      <li>Advanced analytics dashboard</li>
                      <li>Enhanced security features</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="ps-50">
              <h4 className="text-purple font-bold">Phase - 3</h4>
            </div>
          </div>
          <div
            className={`grid grid-cols-2 items-center relative ${
              scrollProgress >= 75 ? "border-after-orange border-after" : ""
            }`}
          >
            <div className="ps-50">
              <h4 className="text-orange font-bold text-end pr-50">
                Phase - 4
              </h4>
            </div>
            <div
              className={`left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute  ${
                scrollProgress >= 75 ? "bg-shadow-orange shadow-after" : ""
              }`}
            >
              <div
                className={` rounded-full h-4 w-4 border-2  ${
                  scrollProgress >= 75
                    ? "bg-orange border-white"
                    : "bg-white border-orange"
                }`}
              ></div>
            </div>
            <div className="relative p-px rounded-lg bg-oranges max-w-[450px] w-full ml-14 lgs:ml-100">
              <div className="h-px w-full -left-14 lgs:-left-[100px] top-1/2 -translate-y-1/2 border-dashed border border-orange absolute -z-10">
                {/* Border Dashed */}
              </div>
              <div class="bg-white rounded-md text-black h-full">
                <div className="p-6 bg-orange/10 rounded-md h-full">
                  <h6 className="text-black font-semibold">
                    Innovation & Expansion
                  </h6>

                  {/* Border */}
                  <div className="h-px w-full bg-borderBlue my-5"></div>

                  {/* Milestones */}
                  <p className="flex items-center gap-3 font-medium mb-2.5">
                    <ArrowOrange />
                    Milestones
                  </p>
                  <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                    <li>Next-gen AI features</li>
                    <li>Global market expansion</li>
                    <li>Advanced customization options</li>
                    <li>Extended platform capabilities</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile */}
        <div className="grid grid-cols-[1px_auto] gap-9 relative lg:hidden  wow animate__animated animate__fadeInUp">
          <div className="border-r border-border_sec"></div>
          <div className="grid gap-5">
            {/* Card 1 */}
            <div className="grid gap-3">
              <h4 className="text-lan_primary font-bold">Phase - 1</h4>

              <div
                className={`relative ${
                  scrollProgress >= 0 ? "border-after-blue border-after" : ""
                }`}
              >
                {/* Round */}
                {/* Round */}
                <div
                  className={`-left-[37.5px] top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute `}
                >
                  <div
                    className={` rounded-full h-4 w-4 border-2  ${
                      scrollProgress >= 0
                        ? "bg-lan_primary border-white bg-shadow-primary shadow-after"
                        : "!border-lan_primary bg-white"
                    }`}
                  ></div>
                </div>

                <div className="h-px w-full max-w-44 -left-9 top-1/2 -translate-y-1/2 border-dashed border border-lan_primary absolute -z-10">
                  {/* Border Dashed */}
                </div>
                <div className="relative p-px rounded-lg bg-blue max-w-[450px] w-full">
                  <div class="bg-white rounded-md text-black h-full">
                    <div className="p-6 bg-lan_primary/10 rounded-md h-full">
                      <h6 className="text-black font-semibold max-tab:!text-sm">
                        Foundation Release{" "}
                      </h6>

                      {/* Border */}
                      <div className="h-px w-full bg-borderBlue my-5"></div>

                      {/* Milestones */}
                      <p className="flex items-center gap-3 font-medium mb-2.5 max-tab:!text-xs">
                        <ArrowBlue />
                        Milestones
                      </p>
                      <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                        <li className="max-tab:text-xs">
                          Core AI integration framework
                        </li>
                        <li className="max-tab:text-xs">
                          Basic warehouse SOP management
                        </li>
                        <li className="max-tab:text-xs">
                          Educational platform MVP
                        </li>
                        <li className="max-tab:text-xs">
                          Initial mentorship features
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="grid gap-3">
              <h4 className="text-green font-bold">Phase - 2</h4>

              <div
                className={`relative ${
                  scrollProgress >= 10 ? "border-after-green border-after" : ""
                }`}
              >
                {/* Round */}
                <div className="-left-[37.5px] top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute bg-shadow-green shadow-after">
                  <div className="bg-green rounded-full h-4 w-4 border-2 border-white"></div>
                </div>
                {/* Round */}
                <div
                  className={`-left-[37.5px] top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute `}
                >
                  <div
                    className={` rounded-full h-4 w-4 border-2  ${
                      scrollProgress >= 10
                        ? "bg-green border-white bg-shadow-green shadow-after"
                        : "!border-green bg-white"
                    }`}
                  ></div>
                </div>

                <div className="h-px w-full max-w-44 -left-9 top-1/2 -translate-y-1/2 border-dashed border border-green absolute -z-10">
                  {/* Border Dashed */}
                </div>
                <div className="relative p-px rounded-lg bg-greens max-w-[450px] w-full">
                  <div class="bg-white rounded-md text-black h-full">
                    <div className="p-6 bg-green/10 rounded-md h-full">
                      <h6 className="text-black font-semibold max-tab:!text-sm">
                        Enhanced Features
                      </h6>

                      {/* Border */}
                      <div className="h-px w-full bg-borderGreen my-5"></div>

                      {/* Milestones */}
                      <p className="flex items-center gap-3 font-medium mb-2.5 max-tab:!text-xs">
                        <ArrowGreen />
                        Milestones
                      </p>
                      <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                        <li className="max-tab:text-xs">
                          Advanced AI algorithms deployment
                        </li>
                        <li className="max-tab:text-xs">
                          Extended warehouse automation
                        </li>
                        <li className="max-tab:text-xs">
                          Interactive learning modules
                        </li>
                        <li className="max-tab:text-xs">
                          Expanded mentorship capabilities
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Card 3 */}
            <div className="grid gap-3">
              <h4 className="text-purple font-bold">Phase - 3</h4>

              <div
                className={`relative ${
                  scrollProgress >= 35 ? "border-after-purpal border-after" : ""
                }`}
              >
                {/* Round */}
                <div
                  className={`-left-[37.5px] top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute `}
                >
                  <div
                    className={` rounded-full h-4 w-4 border-2  ${
                      scrollProgress >= 35
                        ? "bg-purple border-white bg-shadow-purpal shadow-after"
                        : "!border-purple bg-white"
                    }`}
                  ></div>
                </div>

                <div className="h-px w-full max-w-44 -left-9 top-1/2 -translate-y-1/2 border-dashed border border-purple absolute -z-10">
                  {/* Border Dashed */}
                </div>
                <div className="relative p-px rounded-lg bg-purpals max-w-[450px] w-full">
                  <div class="bg-white rounded-md text-black h-full">
                    <div className="p-6 bg-purple/10 rounded-md h-full">
                      <h6 className="text-black font-semibold max-tab:!text-sm">
                        Scale & Integration
                      </h6>

                      {/* Border */}
                      <div className="h-px w-full bg-borderBlue my-5"></div>

                      {/* Milestones */}
                      <p className="flex items-center gap-3 font-medium mb-2.5 max-tab:!text-xs">
                        <ArrowPurpal />
                        Milestones
                      </p>
                      <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                        <li className="max-tab:text-xs">
                          Enterprise-scale deployment options
                        </li>
                        <li className="max-tab:text-xs">
                          Cross-platform integration
                        </li>
                        <li className="max-tab:text-xs">
                          Advanced analytics dashboard
                        </li>
                        <li className="max-tab:text-xs">
                          Enhanced security features
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Card 4 */}
            <div className="grid gap-3">
              <h4 className="text-orange font-bold">Phase - 4</h4>

              <div
                className={`relative ${
                  scrollProgress >= 60 ? "border-after-orange border-after" : ""
                }`}
              >
                {/* Round */}
                <div
                  className={`-left-[37.5px] top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full absolute `}
                >
                  <div
                    className={` rounded-full h-4 w-4 border-2  ${
                      scrollProgress >= 60
                        ? "bg-orange border-white bg-shadow-orange shadow-after"
                        : "!border-orange bg-white"
                    }`}
                  ></div>
                </div>

                <div className="h-px w-full max-w-44 -left-9 top-1/2 -translate-y-1/2 border-dashed border border-orange absolute -z-10">
                  {/* Border Dashed */}
                </div>
                <div className="relative p-px rounded-lg bg-oranges max-w-[450px] w-full">
                  <div class="bg-white rounded-md text-black h-full">
                    <div className="p-6 bg-orange/10 rounded-md h-full">
                      <h6 className="text-black font-semibold max-tab:!text-sm">
                        Innovation & Expansion
                      </h6>

                      {/* Border */}
                      <div className="h-px w-full bg-borderBlue my-5"></div>

                      {/* Milestones */}
                      <p className="flex items-center gap-3 font-medium mb-2.5 max-tab:!text-xs">
                        <ArrowOrange />
                        Milestones
                      </p>
                      <ul className="ps-12 grid gap-2 list-disc [&_li]:text-gray">
                        <li className="max-tab:text-xs">
                          Next-gen AI features
                        </li>
                        <li className="max-tab:text-xs">
                          Global market expansion
                        </li>
                        <li className="max-tab:text-xs">
                          Advanced customization options
                        </li>
                        <li className="max-tab:text-xs">
                          Extended platform capabilities
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
